export const selectGovernments = (state) => state.government.governments;
export const selectGovernmentLoading = (state) => state.government.loading;
export const selectGovernmentError = (state) => state.government.error;
export const selectGovernmentPagination = (state) => state.government.pagination;
export const selectCurrentGovernment = (state) => state.government.currentGovernment;
export const selectGovernmentFilters = (state) => state.government.filters;
